<!--
 * @description     导航器面板
 *
 * @author          重阳
 * @create          2019-10-16 11:00
-->

<template>
  <div class="navigator" id="navigator"></div>
</template>

<script>
  export default {
    name: 'Navigator'
  }
</script>

<style scoped lang="scss">
  .navigator {
    display: inline-block;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>
